module.exports = __webpack_public_path__ + "static/media/chatIcon.f81483e7.png";